import Vue from 'vue'
import router from '../../router'

const state = {
  items: [],
  itemsPerPage: 10,
  currentPage: 1,
  quantityItems: 0,
  quantityPages: 1,
  paginationParams: '',
  sortingParams: '',
  getParams: '',
  url: '/api/contents',
  fields: [],
  initFields: [],
  textContent: [],
  emptyData: false,
  currentParentId: '',
  tabs: [],
  savingInterval: '',
  tabDisabled: true,
  currentTabId: 0,
  isAdd: false,
  isError: false,
  fileExtensions: {},
  showModal: false,
  itemForDelete: {}
}

const mutations = {
  setItems (state, items) {
    state.items = items
  },
  setItemsPerPage (state, itemsPerPage) {
    state.itemsPerPage = itemsPerPage
  },
  setQuantityPages (state, quantityPages) {
    state.quantityPages = quantityPages
  },
  setQuantityItems (state, quantityItems) {
    state.quantityItems = quantityItems
  },
  setCurrentPage (state, currentPage) {
    state.currentPage = currentPage
  },
  setPaginationParams (state, paginationParams) {
    state.paginationParams = paginationParams
  },
  setSortingParams (state, sortingParams) {
    state.sortingParams = sortingParams
  },
  setGetParams (state, getParams) {
    state.getParams = getParams
  },
  setUrl (state, url) {
    state.url = url
  },
  setSavingInterval (state, value) {
    state.savingInterval = value
  },
  setFields (state, fields) {
    state.fields = fields
  },
  setField (state, data) {
    state.fields[data.fieldId][data.fieldPropertyId] = data.value
  },
  initField (state, data) {
    state.fields[`${data.name}${data.index}`] = data.value
  },
  deleteField (state, nameField) {
    delete state.fields[nameField]
  },
  setFieldObject (state, data) {
    state.fields.object.value[data.index] = data
  },
  setInitFields (state, fields) {
    state.initFields = fields
  },
  setFileExtensions (state, fileExtensions) {
    state.fileExtensions = fileExtensions
  },
  setFileExtension (state, data) {
    state.fileExtensions[data.name] = data.value
  },
  setTextContent (state, textContent) {
    state.textContent = textContent
  },
  setCurrentParentId (state, currentParentId) {
    state.currentParentId = currentParentId
  },
  setIsError (state, flag) {
    state.isError = flag
  },
  setErrorField (state, data) {
    state.fields[data.fieldName].errorId = data.errorName
  },
  setIsAdd (state, flag) {
    state.isAdd = flag
  },
  setTabs (state, tabs) {
    state.tabs = tabs
  },
  setTabDisabled (state, flag) {
    state.tabDisabled = flag
  },
  setCurrentTabId (state, id) {
    state.currentTabId = id
  },
  checkFile (state, data) {
    if (state.fileExtensions[data.name].indexOf(data.fileName.toLowerCase().split('.').pop()) === -1) {
      state.fields[data.name].errorId = 'extension'
      state.isError = true
    } else {
      state.fields[data.name].errorId = null
      state.isError = false
    }
  },
  checkFieldFilling (state) {
    let isError = false
    for (let key in state.fields) {
      if (state.fields.hasOwnProperty(key) && state.fields[key].tabId === state.currentTabId) {
        if (state.fields[key].value !== '') {
          switch (state.fields[key].validation) {
            case 'email':
              let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
              if (re.test(String(state.fields[key].value).toLowerCase())) {
                state.fields[key].errorId = null
              } else {
                state.fields[key].errorId = 'email'
                isError = true
              }
              break
            case 'phone':
              if (state.fields[key].value.length > 8 && state.fields[key].value.length < 16) {
                state.fields[key].errorId = null
              } else {
                state.fields[key].errorId = 'phone'
                isError = true
              }
              break
            default:
              state.fields[key].errorId = null
          }
        } else {
          if (!state.fields[key].isNullable) {
            state.fields[key].errorId = 'empty'
            isError = true
          }
        }
      }
    }
    state.isError = isError
  },
  setTabFilledIn (state, flag) {
    state.tabs[state.currentTabId].isFilledIn = flag
  },
  setShowModal (state, flag) {
    state.showModal = flag
  },
  setItemForDelete (state, item) {
    state.itemForDelete = item
  },
  resetModule (state) {
    state.items = []
    state.isAdd = false
    state.fields = []
    state.initFields = []
    state.isError = false
    state.params = []
    state.textContent = []
  }
}

const getters = {
  formattedParameters (state) {
    let formattedParameters = {}
    let array = [],
      object = {}
    for (let key in state.fields) {
      if (state.fields.hasOwnProperty(key)) {
        if (state.fields[key].type === 'slider-img') {
          let imageInfo = {}
          let indexPhoto = key.split('_')[1]
          imageInfo.img = state.fields[key].value
          imageInfo.img_desc = state.fields[`img_desc_${indexPhoto}`].value
          array.push(imageInfo)
        } else if (state.fields[key].type === 'audio-file') {
          if (!object.hasOwnProperty('audio_files')) {
            object.audio_files = []
          }
          let audio = {}
          let index = key.split('_')[1]
          audio.file = state.fields[key].value
          audio.name = state.fields[`name_${index}`].value
          object.audio_files.push(audio)
        } else if (state.fields[key].type === 'object') {
          object[state.fields[key].parameterName] = state.fields[key].value
        } else {
          formattedParameters[state.fields[key].parameterName] = state.fields[key].value
        }
      }
    }
    if (array.length) {
      object = array
    }
    formattedParameters.object = JSON.stringify(object)
    return formattedParameters
  },
  paramsToString (state) {
    let result = '?'
    let params = state.paginationParams.concat(state.getParams, state.sortingParams)
    for (let i = 0; i < params.length; i++) {
      if (params[i].value) {
        result += `${params[i].name}=${params[i].value}&`
      }
    }
    return result.substring(0, result.length - 1)
  },
  isLastTab (state) {
    return (state.tabs.length - 1) === state.currentTabId
  }
}

function translitUrl (string) {
  let cyr2latChars = [
    ['а', 'a'], ['б', 'b'], ['в', 'v'], ['г', 'g'],
    ['д', 'd'], ['е', 'e'], ['ё', 'yo'], ['ж', 'zh'], ['з', 'z'],
    ['и', 'i'], ['й', 'y'], ['к', 'k'], ['л', 'l'],
    ['м', 'm'], ['н', 'n'], ['о', 'o'], ['п', 'p'], ['р', 'r'],
    ['с', 's'], ['т', 't'], ['у', 'u'], ['ф', 'f'],
    ['х', 'h'], ['ц', 'c'], ['ч', 'ch'], ['ш', 'sh'], ['щ', 'shch'],
    ['ъ', ''], ['ы', 'y'], ['ь', ''], ['э', 'e'], ['ю', 'yu'], ['я', 'ya'],

    ['А', 'a'], ['Б', 'b'], ['В', 'v'], ['Г', 'g'],
    ['Д', 'd'], ['Е', 'e'], ['Ё', 'yo'], ['Ж', 'zh'], ['З', 'z'],
    ['И', 'i'], ['Й', 'y'], ['К', 'k'], ['Л', 'l'],
    ['М', 'm'], ['Н', 'n'], ['О', 'o'], ['П', 'p'], ['Р', 'r'],
    ['С', 's'], ['Т', 't'], ['У', 'u'], ['Ф', 'f'],
    ['Х', 'h'], ['Ц', 'c'], ['Ч', 'ch'], ['Ш', 'sh'], ['Щ', 'shch'],
    ['Ъ', ''], ['Ы', 'y'],
    ['Ь', ''],
    ['Э', 'e'],
    ['Ю', 'yu'],
    ['Я', 'ya'],

    ['a', 'a'], ['b', 'b'], ['c', 'c'], ['d', 'd'], ['e', 'e'],
    ['f', 'f'], ['g', 'g'], ['h', 'h'], ['i', 'i'], ['j', 'j'],
    ['k', 'k'], ['l', 'l'], ['m', 'm'], ['n', 'n'], ['o', 'o'],
    ['p', 'p'], ['q', 'q'], ['r', 'r'], ['s', 's'], ['t', 't'],
    ['u', 'u'], ['v', 'v'], ['w', 'w'], ['x', 'x'], ['y', 'y'],
    ['z', 'z'],

    ['A', 'a'], ['B', 'b'], ['C', 'c'], ['D', 'd'], ['E', 'e'],
    ['F', 'f'], ['G', 'g'], ['H', 'h'], ['I', 'i'], ['J', 'j'], ['K', 'k'],
    ['L', 'l'], ['M', 'm'], ['N', 'n'], ['O', 'o'], ['P', 'p'],
    ['Q', 'q'], ['R', 'r'], ['S', 's'], ['T', 't'], ['U', 'u'], ['V', 'v'],
    ['W', 'w'], ['X', 'x'], ['Y', 'y'], ['Z', 'z'],

    [' ', '-'], ['0', '0'], ['1', '1'], ['2', '2'], ['3', '3'],
    ['4', '4'], ['5', '5'], ['6', '6'], ['7', '7'], ['8', '8'], ['9', '9'],
    ['-', '-']
  ]

  let newStr = ''

  for (let i = 0; i < string.length; i++) {
    let ch = string.charAt(i)
    let newCh = ''
    for (let j = 0; j < cyr2latChars.length; j++) {
      if (ch === cyr2latChars[j][0]) {
        newCh = cyr2latChars[j][1]
      }
    }
    newStr += newCh
  }
  return newStr.replace(/[-]{2,}/gim, '-').replace(/\n/gim, '')
}

const actions = {
  checkTabAwailability ({state, commit}) {
    setTimeout(() => {
      commit('setTabDisabled', false)
      for (let key in state.fields) {
        state.isError = false
        state.fields[key].errorId = null
        if (state.fields.hasOwnProperty(key) &&
          state.fields[key].tabId === state.currentTabId &&
          (state.fields[key].parameterName !== 'text' &&
            state.fields[key].parameterName !== 'right_text' &&
            state.fields[key].parameterName !== 'left_text')) {
          if (state.fields[key].value === '') {
            commit('setTabDisabled', true)
          }
        }
      }
    }, 500)
  },
  getItems ({state, commit, getters, dispatch}) {
    state.emptyData = false
    Vue.prototype.$http.get(
      `${state.url}${getters.paramsToString}`
    ).then(response => {
      let data = response.data.data
      for (let item of data) {
        if (item.object) {
          item.object = JSON.parse(item.object)
        }
      }
      commit('setItems', data)
      response.data.data.length ? state.emptyData = false : state.emptyData = true
    }).catch(error => {
      dispatch('notification/errorAxios', error.response.status, {root: true})
      state.emptyData = true
    })
  },
  getQuantityItems ({state, commit, dispatch}, contentId) {
    let searchField, id
    if (!contentId) {
      searchField = 'parent_id'
      id = state.currentParentId
    } else {
      if (!(state.url === '/api/feedback')) {
        searchField = 'content_id'
        id = contentId
      } else {
        searchField = 'type_id'
        id = contentId
      }
    }
    return new Promise((resolve) => {
      Vue.prototype.$http.get(
        `${state.url}/count?search=${id}&searchFields=${searchField}`
      ).then(response => {
        commit('setQuantityItems', response.data.data)
        commit('setQuantityPages', Math.ceil(response.data.data / state.itemsPerPage))
        resolve()
      }).catch(error => {
        dispatch('notification/errorAxios', error.response.status, {root: true})
        state.emptyData = true
      })
    })
  },
  toggleItem ({state, dispatch, rootState}, data) {
    Vue.prototype.$http.put(
      `${state.url}/${data.id}`, {is_active: data.isActive}
    ).then(async res => {
      let lastNews = await Vue.prototype.$http.get(`api/contents?search=parent_id:${rootState.parentId.news};content_id:${res.data.data.id}&searchJoin=and`)
      console.log(lastNews.data.data)
      if (lastNews.data.data.length) {
        let news = lastNews.data.data[0]
        console.log(news)
        Vue.prototype.$http.put(`${rootState.apiUrls.content}/${news.id}`, {is_active: data.isActive}).catch(error => {
          dispatch('notification/errorAxios', error.response.status, {root: true})
        })
      } else {
        if (Object.keys(data).length !== 2) {
          if (data.isActive) {
            console.log('add to news', 'is_active: ' + data.isActive)
            dispatch('addToNews', data)
          } else {
            console.log('not adding to news', 'is_active: ' + data.isActive)
          }
        }
      }
    }).catch(error => {
      dispatch('notification/errorAxios', error.response.status, {root: true})
    })
  },
  addItem ({commit, state, dispatch, getters}) {
    return new Promise(async (resolve) => {
      let data = JSON.parse(JSON.stringify(getters.formattedParameters))
      if (!data.parent_id) data.parent_id = state.currentParentId
      if (!data.url.length && data.title) data.url = translitUrl(data.title)
      if (!data.hasOwnProperty('content_id')) data.content_id = state.currentParentId
      if (data.hasOwnProperty('time_start')) data.date_start += ` ${data.time_start}:00`
      data.is_active = false
      commit('checkFieldFilling')
      if (data.hasOwnProperty('url') && data.url.length) {
        await dispatch('checkUnique', {
          fieldValue: data.url,
          fieldName: 'url',
          message: 'Ссылка должна быть уникальной'
        })
      }
      if (data.hasOwnProperty('title') && data.title.length) {
        await dispatch('checkUnique', {
          fieldValue: data.title,
          fieldName: 'title',
          message: 'Название должно быть уникальным'
        })
      }
      if (!state.isError) {
        Vue.prototype.$http.post(
          state.url, data
        ).then(() => {
          clearInterval(state.savingInterval)
          localStorage.removeItem(window.location.pathname)
          console.log('saving')
          commit('setSavingInterval', '')
          resolve()
          dispatch('getQuantityItems')
          dispatch('notification/triggerSelfDismissingNotification', {
            message: 'Запись успешно добавлена',
            isError: false
          }, {root: true})
        }).catch(error => {
          dispatch('notification/errorAxios', error.response.status, {root: true})
        })
      }
    })
  },
  async deleteItem ({commit, state, dispatch}) {
    let canDelete = true
    if (state.itemForDelete.url !== 'feedback') {
      await Vue.prototype.$http.get(`/api/${state.itemForDelete.url}?search=${state.itemForDelete.id}&searchFields=parent_id`)
        .then(response => {
          if (response.data.data.length) {
            canDelete = false
            commit('setShowModal', false)
            dispatch('notification/triggerSelfDismissingNotification', {
              message: 'Удаление невозможно, к данной записи привязан контент',
              isError: true
            }, {root: true})
          }
        })
    }
    if (canDelete) {
      Vue.prototype.$http.delete(
        `/api/${state.itemForDelete.url}/${state.itemForDelete.id}`
      ).then(() => {
        if (state.itemForDelete.url === 'feedback') dispatch('getNewReviews', null, {root: true})
        dispatch('deleteItemImages', state.itemForDelete)
        dispatch('deleteNews', state.itemForDelete.id)
        dispatch('getItems')
        dispatch('notification/triggerSelfDismissingNotification', {
          message: state.textContent.deleteGreeting,
          isError: false
        }, {root: true})
        commit('setShowModal', false)
        commit('setItemForDelete', {})
      }).catch(error => {
        dispatch('notification/errorAxios', error.response.status, {root: true})
        commit('setShowModal', false)
      })
    }
  },
  deleteItemImages ({rootState, commit}, item) {
    let links = []
    if (item.text) {
      links = item.text.split('<img').join('').split(`${rootState.apiDomain}/`)
      links = links.filter(link => link.startsWith('uploads/'))
    }
    if (links.length) {
      links = links.map((link) => {
        return link.substring(link.indexOf('uploads/') + 8, link.indexOf('"'))
      })
    }
    if (item.img) {
      if (item.img.startsWith(`uploads/`)) {
        links.push(item.img)
      }
    }
    if (item.object) {
      if (item.object.length) {
        item.object.forEach((objectItem) => {
          links.push(objectItem.img)
        })
      }
    }
    if (links.length) {
      links = links.map(link => {
        let newLink = link
        if (link.startsWith(`uploads/`)) {
          newLink = link.substring(8, link.length)
        }

        if (newLink.includes('/')) {
          return newLink.replace('/', '%2F')
        } else {
          return newLink
        }
      })
      links.forEach(async (link) => {
        await Vue.prototype.$http.delete(`/api/destroyfile?url=uploads%2F${link}`)
          .then(() => {
            console.log(`Удалена картинка ${link}`)
          })
          .catch(error => {
            dispatch('notification/errorAxios', error.response.status, {root: true})
            commit('setShowModal', false)
          })
      })
    }
  },
  setNewOrder ({commit, state, dispatch}, data) {
    Vue.prototype.$http.put(`/api/contents/ord/${data.id}`, {
      ord: data.order
    }).then(() => {
      dispatch('getItems')
      dispatch('notification/triggerSelfDismissingNotification', {
        message: 'Порядок элементов сохранен',
        isError: false
      }, {root: true})
    }).catch(error => {
      dispatch('notification/errorAxios', error.response.status, {root: true})
    })
  },
  sendNotification ({rootState, state}, data) {
    // let currentDate = new Date()
    // currentDate.setMinutes(currentDate.getMinutes() + 5)
    Vue.prototype.$http.post(rootState.notificationApiUrl, {
      app_id: '02101ec5-5f80-4be4-9106-5da9d7015c84',
      included_segments: ['All'],
      headings: {'ru': data.title, 'en': data.title},
      contents: {'ru': data.subtext, 'en': data.subtext},
      url: data.link,
      big_picture: `${rootState.apiDomain}/${data.img}`,
      adm_big_picture: `${rootState.apiDomain}/${data.img}`,
      chrome_big_picture: `${rootState.apiDomain}/${data.img}`
      // delayed_option: '+1 minutes'
      // delayed_option: 'timezone',
      // delivery_time_of_day: currentDate.toLocaleTimeString()
    }, {
      headers: {
        Authorization: rootState.notificationApiKey
      }
    })
  },
  onAddItem (context) {
    context.commit('setIsAdd', true)
  },
  modalClose ({commit}) {
    commit('setIsAdd', false)
  },
  checkUnique ({commit, state, dispatch}, data) {
    return new Promise(resolve => {
      Vue.prototype.$http.get(`${state.url}?searchFields=${data.fieldName}&search=${data.fieldValue}`).then((response) => {
        if (response.data.data.length == 1) {
          dispatch('notification/triggerSelfDismissingNotification', {
            message: data.message,
            isError: true
          }, {root: true})
          commit('setIsError', true)
          resolve()
        } else {
          resolve()
        }
      })
    })
  },
  initFields ({commit, dispatch}, fields) {
    let path = window.location.pathname
    if (localStorage.hasOwnProperty(path)) {
      let savedData = JSON.parse(localStorage.getItem(path))
      for (let key in savedData) {
        if (savedData.hasOwnProperty(key) && fields.hasOwnProperty(key)) fields[key].value = savedData[key]
      }
    }
    commit('setInitFields', fields)
    commit('setFields', JSON.parse(JSON.stringify(fields)))
    dispatch('savingData')
  },
  savingData ({commit, state}) {
    let path = window.location.pathname
    let data = {}
    commit('setSavingInterval', setInterval(() => {
      for (let key in state.fields) {
        if (state.fields.hasOwnProperty(key)) {
          if (key === 'text') {
            if (state.fields.text.editor.getData()) {
              data.text = state.fields.text.editor.getData()
            }
          } else {
            if (state.fields[key].value !== '') data[key] = state.fields[key].value
          }
        }
      }
      console.log('Saved data')
      localStorage.setItem(path, JSON.stringify(data))
      console.log('mainpage')
    }, 10000))
  },
  initField ({commit, state}, field) {
    commit('initField', field)
    let newFields = {}
    for (let key in state.fields) {
      newFields[key] = state.fields[key]
    }
    commit('setFields', newFields)
  },
  onNext ({commit, state}) {
    commit('checkFieldFilling')
    if (!state.isError) {
      commit('setTabFilledIn', true)
      commit('setCurrentTabId', ++state.currentTabId)
    }
  },
  onPrev ({commit, state, dispatch}) {
    commit('setCurrentTabId', --state.currentTabId)
    commit('setTabFilledIn', false)
    dispatch('checkTabAwailability')
  },
  deleteNews ({rootState}, content_id) {
    Vue.prototype.$http.get(
      `api/contents?search=parent_id:${rootState.parentId.news};content_id:${content_id}&searchJoin=and`
    ).then(response => {
      let newsArray = response.data.data
      if (newsArray.length) {
        Vue.prototype.$http.delete(`/api/contents/${newsArray[0].id}`)
      }
    })
  },
  async addToNews ({rootState, dispatch}, data) {
    let object = {section_id: data.section_id}
    let section = ''
    if (data.url.categoryId) {
      let categoryData = await Vue.prototype.$http.get(
        `${rootState.apiUrls.content}/${data.url.categoryId}`
      )
      object.category_url = categoryData.data.data.url
    } else {
      object.category_url = ''
    }
    section = rootState.pagesUrl[data.section_id]
    if (data.hasOwnProperty('date_end')) {
      object.date_end = data.date_end
      object.bool = data.bool
      let itemDate = new Date(data.date_end)
      if (!(itemDate > new Date() && data.bool)) {
        section = 'video-otchoty'
      }
    }
    // if (object.category_url === 'besplatnye-seminary') {
    //   object.category_url = 'kruglyj-stol'
    // }
    // console.log(`PUSH URL: https://slav-nayka.com/${section}${object.category_url ? `/${object.category_url}` : ''}/${data.url.articleUrl}`)
    // console.log(`object.category_url: ${object.category_url}`)
    // console.log(`data.url.articleUrl: ${data.url.articleUrl}`)

    data.link = `https://slav-nayka.com/${section}${object.category_url ? `/${object.category_url}` : ''}/${data.url.articleUrl}`
    // data.link = data.link.replace('/besplatnye-seminary', '/kruglyj-stol')

    dispatch('sendNotification', data)
    Vue.prototype.$http.post(
      `${rootState.apiUrls.content}`,
      {
        parent_id: rootState.parentId.news,
        content_id: data.id,
        title: data.title,
        url: data.url.articleUrl,
        img: data.img,
        subtext: data.subtext,
        is_active: true,
        object: JSON.stringify(object)
      }
    ).then(res => {
      console.log(res)
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/mainPage.js